import React from 'react'
import './LoadingPage.css'

function LoadingPage() {
  return (
    // <center><div className="spinner"></div></center>
    <center><div className="progress"></div></center>
  )
}

export default LoadingPage;
